/** @jsxImportSource @emotion/react */
import React from 'react'
import css from '@emotion/css/macro'
import Text from 'src/components/ts-components/Text'
import BusinessAccountIcon from '../BusinessAccountIcon'
import colors from '@sportninja/common/constants/appColors'

interface BusinessAccountInfoProps {
  className?: string
}

const BusinessAccountInfo: React.FC<BusinessAccountInfoProps> = ({
  className,
}) => {
  return (
    <div
      css={css`
        display: inline-flex;
        align-items: center;
        gap: 16px;
        align-self: stretch;
        border-bottom: 1px solid #3f4753;
        padding-bottom: 16px;
      `}
      className={className}
    >
      <div
        css={css`
          width: 32px;
          height: 32px;
          position: relative;
          overflow: hidden;
        `}
      >
        <BusinessAccountIcon size={32} color='#fff' />
      </div>
      <div
        css={css`
          flex: 1 1 0;
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        `}
      >
        <Text variant='paragraphSmall' weight='bold' color={colors.NEUTRAL_0}>
          Start With a Free Trial! No Credit Card Required.
        </Text>
        <Text
          variant='paragraphXSmall'
          weight='regular'
          color={colors.NEUTRAL_50}
        >
          You&apos;re currently on a Player Account. Upgrade to a League Account
          to manage your Leagues, Registrations, and more.
        </Text>
      </div>
    </div>
  )
}

export default BusinessAccountInfo
